import { Team__Apaches } from "./teams/Apaches";
import { Team__FoxImpresos } from "./teams/FoxImpresos";
import { Team__Nogaleros } from "./teams/Nogaleros";
import { Team__Cerveceros } from "./teams/Cerveceros";
import { Team__Aliados } from "./teams/Aliados";
import { Team__FloresMagon } from "./teams/FloresMagon";
import { Team__Coyotes } from "./teams/Coyotes";
import { Team__LaChona } from "./teams/LaChona";

export const teamList_2026_A = [
  Team__Apaches,
  Team__FoxImpresos,
  Team__Nogaleros,
  Team__Cerveceros,
  Team__Aliados,
  Team__FloresMagon,
  Team__Coyotes,
  Team__LaChona,
];
